export default __webpack_public_path__ + "static/hero-banner-836b5031571516797827502f21151333.jpg";